import React from "react";
import FooterThree from "../../common/Footer/FooterThree";
import Menu from "../../common/Menu/Menu";
import CorporateDetailsBanner from "./CorporateDetailsBanner";
import CorporateDetailsSingle from "./CorporateDetailsSingle";

const CorporateDetails = () => {
  return (
    <>
      <Menu header_style_2={true} />
      <CorporateDetailsBanner />
      <CorporateDetailsSingle />
      <FooterThree />
    </>
  );
};

export default CorporateDetails;
